import { render, staticRenderFns } from "./CadastroUser.vue?vue&type=template&id=2a7e9c42&scoped=true"
import script from "./CadastroUser.vue?vue&type=script&lang=js"
export * from "./CadastroUser.vue?vue&type=script&lang=js"
import style0 from "./CadastroUser.vue?vue&type=style&index=0&id=2a7e9c42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7e9c42",
  null
  
)

export default component.exports